<template>
  <div>
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div class="box">
      <admin-box-item title="판넬 관리"
                      subtitle="관리자가 관리자 페이지 및 파트너 페이지의 판넬을 통합적으로 설정 및 관리할 수 있습니다.">
        <panel-setting :page="page"></panel-setting>
      </admin-box-item>
    </div>

    <div class="box">
      <admin-box-item title="상품 상세 정보 기본 양식"
                      subtitle="파트너의 상품 상세 정보 입력 란에 기본으로 표시할 양식을 작성합니다.">
        <lp-editor :text.sync="form_prod_info"></lp-editor>
      </admin-box-item>
    </div>

    <div class="box" v-if="product_setting">
      <admin-box-item title="상품 공통 고시정보 기본값 설정" subtitle="설정값 체크 여부에 따라서 상품등록시 기본으로 사용합니다.">
        <lp-check-bool :checked-val.sync="product_setting.enable_use_info" label="상품 정보 제공 고시" style="margin-bottom:4px"></lp-check-bool>
        <lp-check-bool :checked-val.sync="product_setting.enable_delivery_info" label="배송안내" style="margin-bottom:4px"></lp-check-bool>
        <lp-check-bool :checked-val.sync="product_setting.enable_refund_info" label="교환 및 반품안내"></lp-check-bool>
      </admin-box-item>
    </div>

    <div class="box" v-if="page.path==='product/create' && isPackage(['reservation', 'booking'])">
      <admin-box-item title="예약 상품 일정 반복 옵션"
                      subtitle="예약 상품의 일정 반복을 설정할 때 표시되는 옵션입니다.">
        <div v-for="(item,idx) in page.data" :key="'check-'+idx">
          <lp-check-bool :checkedVal.sync="item.selected"
                         style="margin-bottom:4px"
                         :label="item.label"></lp-check-bool>
        </div>
      </admin-box-item>
    </div>

    <product-package-setting :packages="packages" ref="prodPackSetting"></product-package-setting>


    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
  </div>
</template>
<script>


  import PanelSetting from "../../module/custom/PanelSetting";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import ProductPackageSetting from "./ProductPackageSetting";

  export default {
    components: {
      ProductPackageSetting,
      LpCheckBool,
      PanelSetting},
    data() {
      return {
        page: {},
        packages: [],
        form_prod_info: '',
        product_setting: undefined
      }
    },
    created() {
      this.packages = this.$store.getters.getPackages;
      this.getPanelSetting();
      this.getTextForm();
      this.getProductSetting();
    },
    methods: {
      getProductSetting() {
        this.$axios.get('admin/product/setting').then(res=> {
          this.product_setting = res.data;
        })
      },
      isPackage (packs) {
        if(this.packages.length===0) return false;
        let packages = [];
        this.packages.forEach(item => {
          packages.push(item.name);
        })
        console.log(packages)
        for(let i=0; i<packs.length; i++) {
          if(packages.indexOf(packs[i])>-1) {
            return true;
          }
        }
        return false;
      },
      getTextForm() {
        this.$axios.get('admin/text/form', {
          params: {
            type: 'prod_info'
          }
        }).then(res => {
          if(res.data) {
            this.form_prod_info = res.data.text;
          }
        })
      },
      getPanelSetting() {
        this.$axios.get(this.getUrl('panel/detail/setting'), {
          params: {
            path: 'product/create'
          }
        }).then(res=>{
          let data = res.data;
          let panel9 = find(data.panel, 'panel', 'panel9');
          let panel10 = find(data.panel, 'panel', 'panel10');
          if(!panel9) {
            data.panel.push({
              enable: false,
              panel: "panel9",
              name: "주문 가능 수량 한도"
            })
          }
          if(!panel10) {
            data.panel.push({
              enable: false,
              panel: "panel10",
              name: "상품 SEO 정보"
            })
          }
          this.page = data;
        });
      },
      async save() {
        this.$store.commit('setLoading', true);
        try {
          await this.$axios.patch(`admin/panel/${this.page.id}/setting`, {
            panel: this.page.panel,
            data: this.page.data
          });
          let res2 = await this.$axios.get(this.getUrl('panel/setting'))
          if(res2.data) {
            this.$store.commit('setPanel', res2.data);
          }
          let res3 = await this.$axios.post(`admin/text/form`, {
            type: 'prod_info',
            text: this.form_prod_info
          })
          if(res3.status===200) this.getTextForm();
          await this.$axios.patch('admin/product/setting', this.product_setting)
          await this.$refs.prodPackSetting.save();
          this.toast('변경사항이 저장되었습니다.');
          this.$store.commit('setLoading', false);
        } catch(err) {
          this.$store.commit('setLoading', false);
          this.toast('서버에 오류가 있습니다.');
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
